module.exports = __webpack_public_path__ + "static/fundraise_pic-d9621ca3a40702163c5f7bf708f0296d.png";